// TypeScript-equivalent DTOs matching ClearView Data Models > Quality > DTOs > QuestionDTO, QuestionGroupDTO

export interface QuestionDTO {
    QuestionID: number;
    QuestionGroupID: number;
    QuestionName: string;
    QuestionDescription: string;
    QuestionPath: string;
    QuestionType: QuestionType;
    QuestionWeight: number;
    Active: boolean;
    Position: number;
    OrderPosition: number;
    DisplayPosition: string;
    DependentID: number;
    HasDependents: boolean;
    CompanyID: number;
    showInGrid: boolean;
    isSelected: boolean;
    SelectedAnswerIndex: number;
    SelectedAnswer: string;
};

export interface QuestionGroupDTO {
    QuestionGroupID: number;
    QuestionGroupName: string;
    QuestionGroupDescription: string;
    CompanyID: number;
    ApplicationID: number;
    Active: boolean;
    isGlobal: boolean;
    Position: number;
    showInGrid: boolean;
    isSelected: boolean;
};

export enum QuestionType {
    Invalid = -1,
    HorizontalRadioList = 0,
    VerticalRadioList = 1,
    DropDownList = 2,
    Text = 3,
    Checkbox = 4,
    YesNo = 5,
    MultiSelect = 6
};
